import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { textCapitalize } from "../../../Helpers/Utils";
import { SERVICE_TYPES } from "../shared/vehicleFleetConstants";

const ServiceUpdateModal = ({ service, onClose, onSaved }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const [serviceName, setServiceName] = useState(service?.serviceName || "");
    const [serviceType, setServiceType] = useState(service?.serviceType || SERVICE_TYPES[0]);
    const [staffId, setStaffId] = useState(service?.staffId || "");
    const [staffOptions, setStaffOptions] = useState([]);
    const [loadingStaff, setLoadingStaff] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        (async () => {
            setLoadingStaff(true);
            const response = await Handler({ method: "post", url: "/staff/list/0?count=100", data: { employmentStatus: "active" } });
            setStaffOptions(response?.success ? response?.data?.data?.list || [] : []);
            setLoadingStaff(false);
        })();
    }, []);

    const onSubmit = async () => {
        if (!serviceName.trim()) {
            toast.error("Service name is required");
            return;
        }
        if (!staffId) {
            toast.error("Select a staff member");
            return;
        }
        setSaving(true);
        const response = await Handler({
            method: "patch",
            url: `/staff/service/${service?.serviceId}`,
            data: { serviceName: serviceName.trim(), serviceType, staffId },
        });
        if (response?.success) {
            toast.success(response?.data?.message || "Updated successfully");
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to update service"));
        }
        setSaving(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title fw-semibold">Edit Service</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row g-3">
                            <div className="col-12">
                                <label className="form-label">Service name</label>
                                <input type="text" className="form-control" value={serviceName} onChange={(e) => setServiceName(e.target.value)} placeholder="e.g. Oil change" />
                            </div>
                            <div className="col-12 col-md-6">
                                <label className="form-label">Service type</label>
                                <select className="form-select" value={serviceType} onChange={(e) => setServiceType(e.target.value)}>
                                    {SERVICE_TYPES.map((t) => (<option key={t} value={t}>{t}</option>))}
                                </select>
                            </div>
                            <div className="col-12 col-md-6">
                                <label className="form-label">Assigned staff</label>
                                <select className="form-select" value={staffId} onChange={(e) => setStaffId(e.target.value)} disabled={loadingStaff}>
                                    <option value="" disabled>{loadingStaff ? "Loading staff..." : "Select staff member"}</option>
                                    {staffOptions.map((s) => (<option key={s.staffId} value={s.staffId}>{s.name} - {s.designation}</option>))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={saving}>
                            {saving ? "Saving..." : "Save"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceUpdateModal;
